/* ============================================================================
   HOTELIER BY FLUFFCO — scoped interactions
   Loaded ONLY by layout/hotelier.liquid. All selectors are confined to the
   Hotelier markup; nothing here touches the main FluffCo storefront.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('.hotelier-page');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Canonical scent data (single island, shared by Compare + Shop) */
  var scentData = [];
  var scentEl = root.querySelector('[data-hotelier-scents]');
  if (scentEl) { try { scentData = JSON.parse(scentEl.textContent); } catch (e) { scentData = []; } }

  /* ---- Header + two-stage welcome offer (IM8 pattern) -------------------- */
  var header = document.querySelector('[data-hotelier-header]');
  if (header) {
    var onScroll = function () {
      var y = window.scrollY;
      if (y > window.innerHeight * 0.7) header.classList.add('is-solid');
      else header.classList.remove('is-solid');
      /* stage 1 bar slides away once you start scrolling */
      root.classList.toggle('is-scrolled', y > 24);
      /* stage 2 offer bar takes over deeper down the page */
      root.classList.toggle('is-offer', y > 560);
      var offerbar = document.querySelector('[data-hotelier-offerbar]');
      if (offerbar) offerbar.setAttribute('aria-hidden', y > 560 ? 'false' : 'true');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Welcome-offer countdown: to midnight local, refreshes daily ------- */
  var annCount = document.querySelector('[data-ann-count]');
  if (annCount) {
    var tick = function () {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      var hh = Math.floor(d / 3600), mm = Math.floor((d % 3600) / 60), ss = d % 60;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      annCount.textContent = pad(hh) + ':' + pad(mm) + ':' + pad(ss);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Smooth anchor scroll (offset for fixed header) ------------------- */
  document.querySelectorAll('.hotelier-page a[href^="#"], .hotelier-header a[href^="#"], .hotelier-drawer a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      closeDrawer();
    });
  });

  /* ---- Mobile drawer ----------------------------------------------------- */
  var drawer = document.querySelector('[data-hotelier-drawer]');
  var openBtn = document.querySelector('[data-hotelier-menu-open]');
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  document.querySelectorAll('[data-hotelier-menu-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

  /* ---- Reveal on scroll -------------------------------------------------- */
  var reveals = root.querySelectorAll('[data-h-reveal]');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });

    /* Safety net: if IO is stalled (prerender/odd mobile states), reveal
       anything already in view on scroll so content can never stay hidden. */
    var revealTick = 0;
    function revealSweep() {
      var now = Date.now();
      if (now - revealTick < 250) return;
      revealTick = now;
      reveals.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.96 && r.bottom > 0) { el.classList.add('is-in'); io.unobserve(el); }
      });
    }
    window.addEventListener('scroll', revealSweep, { passive: true });
    window.addEventListener('touchmove', revealSweep, { passive: true });
  }

  /* ---- Accordion --------------------------------------------------------- */
  root.querySelectorAll('[data-acc]').forEach(function (btn) {
    var item = btn.closest('.hotelier-acc__item');
    var panel = item ? item.querySelector('.hotelier-acc__panel') : null;
    function setOpen(open) {
      if (!panel) return;
      item.classList.toggle('is-open', open);
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    }
    if (item && item.classList.contains('is-open')) setOpen(true);
    btn.addEventListener('click', function () { setOpen(!item.classList.contains('is-open')); });
  });

  /* ---- Attribution: remember how this visitor entered the Hotelier LP ----
     First touch wins for the session. The value is written onto the cart as
     attributes at add-to-cart time, so every resulting ORDER carries it
     (visible in Shopify admin + exports = hard conversion data for this page). */
  var HOT_ATTR_KEY = 'hotelierEntry';
  (function captureEntry() {
    try {
      if (sessionStorage.getItem(HOT_ATTR_KEY)) return;
      var q = new URLSearchParams(window.location.search);
      var entry = {
        source: q.get('utm_source') || (document.referrer && document.referrer.indexOf(location.host) === -1 ? 'referral:' + (document.referrer.split('/')[2] || '') : 'direct'),
        medium: q.get('utm_medium') || '',
        campaign: q.get('utm_campaign') || '',
        landed: new Date().toISOString().slice(0, 16)
      };
      sessionStorage.setItem(HOT_ATTR_KEY, JSON.stringify(entry));
    } catch (e) {}
  })();
  function tagCartWithEntry() {
    var entry = null;
    try { entry = JSON.parse(sessionStorage.getItem(HOT_ATTR_KEY) || 'null'); } catch (e) {}
    var attrs = { 'Hotelier LP': 'yes' };
    if (entry) {
      attrs['Hotelier source'] = entry.source || 'direct';
      if (entry.medium) attrs['Hotelier medium'] = entry.medium;
      attrs['Hotelier landed'] = entry.landed || '';
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  /* Apply a discount code to the CART SESSION (server-side cookie), so
     checkout charges the promised offer total no matter which path the
     shopper takes there (drawer button, /cart page, dynamic checkout).
     Passing null applies a non-existent code, which clears any prior one. */
  function applyDiscountSession(code) {
    return fetch('/discount/' + (code || 'HOTELIER-NONE'), { credentials: 'same-origin' }).catch(function () {});
  }
  function rememberOffer(offer) {
    try { sessionStorage.setItem('hotelierOffer', JSON.stringify(offer || null)); } catch (e) {}
  }
  function recallOffer() {
    try { return JSON.parse(sessionStorage.getItem('hotelierOffer') || 'null'); } catch (e) { return null; }
  }

  /* ---- "Try it once" module (Version C): $20 first bottle --------------- */
  var tryBtn = root.querySelector('[data-hotelier-tryit]');
  if (tryBtn) {
    tryBtn.addEventListener('click', function () {
      if (tryBtn.hasAttribute('disabled')) return;
      var sel = root.querySelector('.hotelier-scent-opt.is-active') || root.querySelector('.hotelier-scent-opt');
      var v = sel ? sel.getAttribute('data-variant-id') : '';
      if (!v) { var sh = document.getElementById('shop'); if (sh) sh.scrollIntoView({ behavior: 'smooth' }); return; }
      var lbl = tryBtn.querySelector('[data-tryit-label]');
      tryBtn.setAttribute('disabled', '');
      if (lbl) lbl.textContent = 'Heading to checkout\u2026';
      fetch('/discount/HTLR-TRY-K4T9', { credentials: 'same-origin' }).catch(function () {})
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(v), quantity: 1 }] })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return tagCartWithEntry(); })
        .then(function () { window.location.href = '/discount/HTLR-TRY-K4T9?redirect=%2Fcheckout'; })
        .catch(function () {
          if (lbl) lbl.textContent = 'Try again';
          setTimeout(function () { if (lbl) lbl.textContent = 'Try it'; tryBtn.removeAttribute('disabled'); }, 1600);
        });
    });
  }

  /* ---- Shop: scent selector, quantity, add-to-cart ---------------------- */
  var shop = root.querySelector('[data-hotelier-shop]');
  if (shop) {
    var opts = shop.querySelectorAll('.hotelier-scent-opt');
    var addBtn = shop.querySelector('[data-hotelier-add]');
    var addLabel = shop.querySelector('[data-add-label]');
    var currentScent = shop.querySelector('.hotelier-scent-opt.is-active') || opts[0];

    /* Per-city media + scent story (description, top/heart/base) */
    var shopMedia = root.querySelector('[data-shop-media]');
    var elChar = shop.querySelector('[data-scent-character]');
    var elDesc = shop.querySelector('[data-scent-desc]');
    var elTop = shop.querySelector('[data-scent-top]');
    var elHeart = shop.querySelector('[data-scent-heart]');
    var elBase = shop.querySelector('[data-scent-base]');
    var thumbsWrap = root.querySelector('[data-shop-thumbs]');
    var shopMedal = root.querySelector('[data-shop-medal]');
    function setMedal(onFirst) { if (shopMedal) shopMedal.classList.toggle('is-hidden', !onFirst); }

    /* ---- Gallery films: appended to every scent's thumbs. The 9:16 video
       plays fully inset over a blurred cover-fill copy of itself. ---- */
    var FILMS = [];
    var filmsEl = root.querySelector('[data-shop-films]');
    if (filmsEl) { try { FILMS = JSON.parse(filmsEl.textContent) || []; } catch (e) { FILMS = []; } }
    var filmWrap = root.querySelector('[data-shop-film]');
    var filmBg = root.querySelector('[data-film-bg]');
    var filmFg = root.querySelector('[data-film-fg]');
    var filmSound = root.querySelector('[data-film-sound]');
    function setSoundUI() {
      if (!filmSound || !filmFg) return;
      filmSound.classList.toggle('is-on', !filmFg.muted);
      filmSound.setAttribute('aria-label', filmFg.muted ? 'Unmute video' : 'Mute video');
    }
    function stopFilm() {
      if (!filmWrap || filmWrap.hidden) return;
      if (filmFg) { filmFg.pause(); filmFg.muted = true; }
      if (filmBg) filmBg.pause();
      filmWrap.hidden = true;
      if (shopMedia) shopMedia.style.display = '';
      setSoundUI();
    }
    function playFilm(f) {
      if (!filmWrap || !filmFg || !f || !f.src) return;
      if (shopMedia) shopMedia.style.display = 'none';
      setMedal(false);
      filmWrap.hidden = false;
      if (filmFg.getAttribute('src') !== f.src) {
        if (f.poster) filmFg.setAttribute('poster', f.poster);
        filmFg.setAttribute('src', f.src);
        if (filmBg) filmBg.setAttribute('src', f.src);
      }
      filmFg.muted = true;
      if (filmBg) filmBg.muted = true;
      setSoundUI();
      var p = filmFg.play(); if (p && p.catch) p.catch(function () {});
      if (filmBg) { var q = filmBg.play(); if (q && q.catch) q.catch(function () {}); }
    }
    if (filmSound && filmFg) {
      filmSound.addEventListener('click', function () {
        filmFg.muted = !filmFg.muted;
        setSoundUI();
      });
    }

    function setMainMedia(src, name) {
      if (!shopMedia || !src) return;
      stopFilm();
      shopMedia.style.opacity = '0';
      var img = new Image();
      img.onload = function () { shopMedia.src = src; shopMedia.alt = 'Hotelier room fragrance — ' + name; shopMedia.style.opacity = ''; };
      img.src = src;
    }
    function renderThumbs(i) {
      if (!thumbsWrap) return;
      var s = scentData[i]; if (!s) return;
      var gal = s.gallery && s.gallery.length ? s.gallery : (s.img ? [s.img] : []);
      /* Images for this scent, then the shared films (same two on all scents). */
      var items = gal.map(function (src) { return { img: src }; }).concat(FILMS.map(function (f) { return { film: f }; }));
      thumbsWrap.innerHTML = items.map(function (it, k) {
        var isFilm = !!it.film;
        var tsrc = isFilm ? (it.film.poster || '') : it.img;
        var talt = isFilm ? (it.film.label || 'Hotelier film') : s.name + ' image ' + (k + 1);
        return '<button type="button" class="hotelier-thumb' + (k === 0 ? ' is-active' : '') + (isFilm ? ' hotelier-thumb--film' : '') + '" role="option" aria-selected="' + (k === 0) + '" data-thumb="' + k + '">' +
          '<img src="' + tsrc + '" alt="' + talt + '" loading="lazy">' +
          (isFilm ? '<span class="hotelier-thumb__play" aria-hidden="true"><svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>' : '') +
          '</button>';
      }).join('');
      thumbsWrap.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          thumbsWrap.querySelectorAll('[data-thumb]').forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
          t.classList.add('is-active'); t.setAttribute('aria-selected', 'true');
          var gi = parseInt(t.getAttribute('data-thumb'), 10);
          var it = items[gi];
          if (it && it.film) { playFilm(it.film); return; }
          setMainMedia(it ? it.img : gal[gi], s.name);
          setMedal(gi === 0);
        });
      });
    }
    function renderScentStory(i) {
      var s = scentData[i]; if (!s) return;
      setMainMedia(s.gallery && s.gallery[0] ? s.gallery[0] : s.img, s.name);
      renderThumbs(i);
      setMedal(true);
      if (elChar) elChar.textContent = s.character;
      if (elDesc) elDesc.textContent = s.desc;
      if (elTop) elTop.textContent = s.top;
      if (elHeart) elHeart.textContent = s.heart;
      if (elBase) elBase.textContent = s.base;
      var nameLabel = shop.querySelector('[data-scent-name-label]');
      if (nameLabel) nameLabel.textContent = s.name;
      /* keep the notes accordion height correct if it's open */
      var accItem = elChar && elChar.closest('.hotelier-acc__item');
      if (accItem && accItem.classList.contains('is-open')) {
        var pnl = accItem.querySelector('.hotelier-acc__panel');
        if (pnl) pnl.style.maxHeight = pnl.scrollHeight + 'px';
      }
    }
    if (shopMedia) shopMedia.style.transition = 'opacity .45s ease';

    /* ---- Scent (city) selection ---- */
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (opt.getAttribute('data-soldout') === 'true') return;
        opts.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false'); });
        opt.classList.add('is-active'); opt.setAttribute('aria-checked', 'true');
        currentScent = opt;
        var si = parseInt(opt.getAttribute('data-scent-index'), 10);
        if (!isNaN(si)) renderScentStory(si);
        /* 60-day mix follows the selected scent until customised per-slot */
        if (window.hotelierResetMix2) window.hotelierResetMix2();
      });
    });
    if (currentScent) { var ci = parseInt(currentScent.getAttribute('data-scent-index'), 10); if (!isNaN(ci)) renderScentStory(ci); }

    /* ---- Purchase module: expandable plan cards with nested sizes (IM8) ---- */
    var buy = shop.querySelector('[data-hotelier-buy]');
    if (buy) {
      var cfg = { tiers: {}, single: 69, cadence: 'every 2 months' };
      var offEl = shop.querySelector('[data-hotelier-offers]');
      try { cfg = JSON.parse(offEl.textContent); } catch (e) {}
      var planCards = buy.querySelectorAll('.hotelier-plancard--exp');
      var sizeRows = buy.querySelectorAll('[data-size]');
      var dueTotal = buy.querySelector('[data-due-total]');
      var dueNote = buy.querySelector('[data-due-note]');
      var dueSave = buy.querySelector('[data-due-save]');
      var tier = '4', plan = 'sub', tierOne = '4';
      var leadCard = buy.querySelector('.hotelier-plancard--exp.is-active');
      if (leadCard) { plan = leadCard.getAttribute('data-plan') || plan; tier = leadCard.getAttribute('data-tier') || tier; }
      var M = function (n) { return '$' + Math.floor(Math.round(n * 100) / 100 + 1e-9); }; // whole dollars, rounded DOWN (11/3/26)
      function offer(t) { return cfg.tiers[t] || { one: 0, sub: 0 }; }
      function qtyOf(t) { return parseInt(t, 10); }

      /* Mix & match: which scent goes in each bottle of the 60/90-day tiers.
         90-day defaults to one of each; 60-day defaults to the selected scent x2. */
      var mixEls = buy.querySelectorAll('[data-mix]');
      var mixes = { '2': null, '4': [0, 1, 2, 3] };
      function selIdx() { return currentScent ? (parseInt(currentScent.getAttribute('data-scent-index'), 10) || 0) : 0; }
      function renderMix() {
        var q = qtyOf(tier);
        mixEls.forEach(function (wrap) {
          var host = wrap.closest('.hotelier-plancard--exp');
          var hostOn = host && host.classList.contains('is-active');
          if (!hostOn) { wrap.innerHTML = ''; return; }
          if ((tier === '1' || tier === '2') && !mixes[tier]) {
            mixes[tier] = []; for (var mi = 0; mi < q; mi++) mixes[tier].push(selIdx());
          }
          var mix = mixes[tier];
          wrap.innerHTML = '<span class="hotelier-mix__label">' + (q === 1 ? 'Choose your bottle' : 'Choose your ' + q + ' bottles') + '</span>' +
            mix.map(function (sIdx, slot) {
              var free = (tier === '4' && slot === 3);
              return '<div class="hotelier-mix__row' + (free ? ' is-free' : '') + '" data-mix-slot="' + slot + '">' +
                '<span class="hotelier-mix__slot">Bottle ' + (slot + 1) + (free ? '<b class="free">Free</b>' : '') + '</span>' +
                '<span class="hotelier-mix__name">' + (scentData[sIdx] ? scentData[sIdx].name : '') + '</span>' +
                '<span class="hotelier-mix__dots">' + scentData.map(function (sc, k) {
                  return '<button type="button" class="hotelier-mix__dot' + (k === sIdx ? ' is-active' : '') + '" data-mix-pick="' + k + '"' +
                    ' style="--c:' + sc.color + '" aria-label="' + sc.name + '" title="' + sc.name + '"></button>';
                }).join('') + '</span></div>';
            }).join('');
        });
        buy.querySelectorAll('[data-mix-slot]').forEach(function (row) {
          var slot = parseInt(row.getAttribute('data-mix-slot'), 10);
          row.querySelectorAll('[data-mix-pick]').forEach(function (dot) {
            dot.addEventListener('click', function (e) {
              e.stopPropagation();
              var pick = parseInt(dot.getAttribute('data-mix-pick'), 10);
              /* 30-day is a single bottle: picking here also drives the main
                 "Choose your scent" selector (which resets this mix to match). */
              if (tier === '1' && opts[pick]) { opts[pick].click(); return; }
              mixes[tier][slot] = pick;
              renderMix(); expand();
            });
          });
        });
      }

      function expand() {
        planCards.forEach(function (card) {
          var cPlan = card.getAttribute('data-plan');
          var on = cPlan === plan && card.getAttribute('data-tier') === tier;
          card.classList.toggle('is-active', on);
          var head = card.querySelector('[data-plan-head]');
          if (head) head.setAttribute('aria-checked', on ? 'true' : 'false');
          var body = card.querySelector('[data-plan-body]');
          if (body) body.style.maxHeight = on ? body.scrollHeight + 'px' : '0px';
        });
      }

      var CADENCE = { '1': 'every month', '2': 'every 2 months', '4': 'every 3 months' };
      var MONTHS = { '1': 1, '2': 2, '4': 3 };
      function renderPrices() {
        planCards.forEach(function (card) {
          var cPlan = card.getAttribute('data-plan');
          var cTier = card.getAttribute('data-tier');
          var o = offer(cTier); var q = qtyOf(cTier);
          var price = cPlan === 'sub' ? o.sub : o.one;
          var mo = MONTHS[cTier] || 1;
          var set = function (sel, txt) { var el = card.querySelector(sel); if (el) el.textContent = txt; };
          set('[data-headprice]', M(price));
          /* Lead price = per-bottle, struck against the $69 single-bottle price */
          set('[data-price]', M(price / q));
          set('[data-was]', M(cfg.single));
          if (cPlan === 'sub') {
            set('[data-billed]', 'Billed ' + M(price) + ' ' + (CADENCE[cTier] || 'every 2 months') + '. Skip or cancel anytime.');
          }
        });
        /* one-time size rows */
        sizeRows.forEach(function (row) {
          var t = row.getAttribute('data-size'); var ro = offer(t); var rq = qtyOf(t);
          var pEl = row.querySelector('[data-size-price]');
          var sEl = row.querySelector('[data-size-save]');
          if (pEl) pEl.textContent = M(ro.one);
          if (sEl) {
            var saved = cfg.single * rq - ro.one;
            if (rq === 4) sEl.textContent = 'Pay for 3, get 4';
            else sEl.textContent = saved > 0 ? 'Save ' + M(saved) : (rq > 1 ? '' : M(ro.one / rq) + ' / bottle');
          }
          var on = plan === 'one' && t === tier;
          row.classList.toggle('is-active', on);
          row.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }

      function renderDue() {
        var o = offer(tier); var q = qtyOf(tier);
        var due = plan === 'sub' ? o.sub : o.one;
        if (dueTotal) dueTotal.textContent = M(due);
        if (dueNote) dueNote.textContent = plan === 'sub'
          ? 'Then ' + M(due) + ' ' + (CADENCE[tier] || 'every 2 months') + '. Skip or cancel anytime.'
          : 'One-time payment. No subscription.';
        var saved = cfg.single * q - due;
        if (dueSave) {
          dueSave.textContent = saved > 0 ? 'You save ' + M(saved) + ' vs single bottles' : '';
          dueSave.style.display = dueSave.textContent ? '' : 'none';
        }
        if (addLabel) addLabel.textContent = (plan === 'sub' ? 'Subscribe' : 'Add to Cart') + ' — ' + M(due);
      }

      function renderAll() {
        planCards.forEach(function (card) {
          var cPlan = card.getAttribute('data-plan');
          card.classList.toggle('is-active', cPlan === plan && (cPlan === 'one' || card.getAttribute('data-tier') === tier));
        });
        renderPrices(); renderDue(); renderMix(); expand();
      }

      planCards.forEach(function (card) {
        var head = card.querySelector('[data-plan-head]');
        if (head) head.addEventListener('click', function () {
          plan = card.getAttribute('data-plan');
          tier = card.getAttribute('data-tier') || tier;
          renderAll();
        });
      });
      sizeRows.forEach(function (row) {
        row.addEventListener('click', function () {
          tier = tierOne = row.getAttribute('data-size');
          plan = 'one';
          renderAll();
        });
      });
      window.hotelierResetMix2 = function () { mixes['1'] = null; mixes['2'] = null; if (tier === '1' || tier === '2') { renderMix(); expand(); } };

      /* Returning from checkout via the browser Back button restores the page
         from the back-forward cache exactly as it was left — with the buy
         button disabled and stuck on "Heading to checkout…". Reset it. */
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        if (addBtn) addBtn.removeAttribute('disabled');
        var ob = buy.querySelector('[data-onetime-add]');
        if (ob && ob.__initialHtml) { ob.innerHTML = ob.__initialHtml; ob.removeAttribute('disabled'); }
        renderAll(); /* repaints the ATC label, due row and prices */
      });

      /* One-time purchase link: one bottle of the selected scent, straight to cart */
      var oneBtn = buy.querySelector('[data-onetime-add]');
      if (oneBtn) {
        var onePriceEl = oneBtn.querySelector('[data-onetime-price]');
        if (onePriceEl) onePriceEl.textContent = M(offer('1').one || cfg.single);
        oneBtn.__initialHtml = oneBtn.innerHTML;
        oneBtn.addEventListener('click', function () {
          if (oneBtn.hasAttribute('disabled')) return;
          var v = currentScent ? currentScent.getAttribute('data-variant-id') : '';
          if (!v) return;
          applyDiscountSession(null); /* full-price single: clear any sub code */
          rememberOffer(null);
          document.querySelectorAll('[data-cart-checkout]').forEach(function (a) { a.setAttribute('href', '/checkout'); });
          var url = (shop.getAttribute('data-cart-add')) || (window.routes && window.routes.cart_add_url) || '/cart/add.js';
          var prevHtml = oneBtn.innerHTML;
          oneBtn.textContent = 'Adding…'; oneBtn.setAttribute('disabled', '');
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(v), quantity: 1 }] })
          })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () {
              /* Straight to checkout — same flow as the subscription button. */
              oneBtn.textContent = 'Heading to checkout\u2026';
              return tagCartWithEntry().then(function () { window.location.href = '/checkout'; });
            })
            .catch(function () {
              oneBtn.textContent = 'Try again';
              setTimeout(function () { oneBtn.innerHTML = prevHtml; oneBtn.removeAttribute('disabled'); }, 1600);
            });
        });
      }
      window.addEventListener('load', expand);
      renderAll();

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (addBtn.hasAttribute('disabled')) return;
          var q = qtyOf(tier);
          var items = [];
          if (mixes[tier] && mixes[tier].length) {
            /* Build from the per-bottle slot picks */
            var counts = {};
            mixes[tier].forEach(function (sIdx) {
              var o = opts[sIdx]; var v = o && o.getAttribute('data-variant-id');
              if (v) counts[v] = (counts[v] || 0) + 1;
            });
            Object.keys(counts).forEach(function (v) { items.push({ id: Number(v), quantity: counts[v] }); });
          } else {
            var v = currentScent ? currentScent.getAttribute('data-variant-id') : '';
            if (v) items.push({ id: Number(v), quantity: q });
          }
          if (!items.length) return;
          /* Preferred path: a real selling plan (Shopify subscriptions app).
             Set the plan ids in the [data-hotelier-offers] island ("plans")
             and the subscription pricing flows natively to cart + checkout —
             no discount codes involved. Until then, fall back to the exact
             discount codes, applied to the CART SESSION at add time. */
          var planId = plan === 'sub' && cfg.plans ? cfg.plans[tier] : null;
          var ccode = null;
          if (planId) {
            items.forEach(function (it) { it.selling_plan = Number(planId); });
          } else {
            /* Default: no codes — the Suite's $199 comes from the storewide
               automatic discount. A page's offers island may declare its own
               checkout codes via "codes": {"one": {"1": "CODE", ...}} for
               page-specific test pricing (Version C). */
            var CODES = (cfg.codes && typeof cfg.codes === 'object') ? cfg.codes : { one: {}, sub: {} };
            ccode = (CODES[plan] || {})[tier] || null;
          }
          applyDiscountSession(ccode);
          var offerTotal = plan === 'sub' ? offer(tier).sub : offer(tier).one;
          var offerCount = items.reduce(function (n, it) { return n + it.quantity; }, 0);
          rememberOffer(ccode ? { code: ccode, total: offerTotal, count: offerCount } : null);
          document.querySelectorAll('[data-cart-checkout]').forEach(function (a) {
            a.setAttribute('href', ccode ? '/discount/' + ccode + '?redirect=%2Fcheckout' : '/checkout');
          });
          var url = (shop.getAttribute('data-cart-add')) || (window.routes && window.routes.cart_add_url) || '/cart/add.js';
          var prev = addLabel ? addLabel.textContent : '';
          if (addLabel) addLabel.textContent = 'Adding…';
          addBtn.setAttribute('disabled', '');
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () {
              /* Straight to checkout — the session discount (or selling plan)
                 is already attached, so totals match the page. */
              if (addLabel) addLabel.textContent = 'Heading to checkout…';
              return tagCartWithEntry().then(function () {
                window.location.href = ccode ? '/discount/' + ccode + '?redirect=%2Fcheckout' : '/checkout';
              });
            })
            .catch(function () {
              if (addLabel) addLabel.textContent = 'Try again';
              setTimeout(function () { if (addLabel) addLabel.textContent = prev; addBtn.removeAttribute('disabled'); }, 1600);
            });
        });
      }
    }

  }

  /* ---- Fragrance comparison chart --------------------------------------- */
  var compare = root.querySelector('[data-hotelier-compare]');
  if (compare) {
    var scents = scentData;
    var slides = compare.querySelectorAll('[data-compare-slide]');
    var dots = root.querySelectorAll('[data-compare-dot]');
    var chart = root.querySelector('[data-compare-chart]');
    var FAM_LABELS = { woody:'Woody', amber:'Amber', floral:'Floral', fresh:'Fresh', citrus:'Citrus', spicy:'Spicy', green:'Green', musk:'Musk', resinous:'Resinous', smoky:'Smoky', powdery:'Powdery', herbal:'Herbal' };
    var elNo = root.querySelector('[data-compare-no]');
    var elName = root.querySelector('[data-compare-name]');
    var elNotes = root.querySelector('[data-compare-notes]');
    var elCmpDesc = root.querySelector('[data-compare-desc]');
    var elTop = root.querySelector('[data-compare-top]');
    var elHeart = root.querySelector('[data-compare-heart]');
    var elBase = root.querySelector('[data-compare-base]');
    var elPrice = root.querySelector('[data-compare-price]');
    var elPair = root.querySelector('[data-compare-pair]');
    var idx = 0;

    function renderCompare(i) {
      var n = scents.length; if (!n) return;
      idx = (i + n) % n;
      var s = scents[idx];
      slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); d.setAttribute('aria-selected', k === idx ? 'true' : 'false'); });
      if (elNo) elNo.textContent = 'N° ' + s.no;
      if (elName) elName.textContent = s.name;
      if (elNotes) elNotes.textContent = s.character;
      if (elCmpDesc) elCmpDesc.textContent = s.desc;
      if (elTop) elTop.textContent = s.top || '';
      if (elHeart) elHeart.textContent = s.heart || '';
      if (elBase) elBase.textContent = s.base || '';
      if (elPrice) {
        if (!s.price || /X/.test(s.price)) elPrice.innerHTML = '<span class="placeholder">' + (s.price || '$XX.XX') + '</span>';
        else elPrice.textContent = s.price;
      }
      if (chart) {
        var entries = Object.keys(s.fam || {}).map(function (k) { return [k, s.fam[k]]; })
          .sort(function (a, b) { return b[1] - a[1]; });
        chart.innerHTML = entries.map(function (e) {
          var dom = e[1] >= 2;
          return '<span class="hotelier-famchip' + (dom ? ' is-dom' : '') + '" style="background:' + s.color +
            (dom ? '' : '73') + ';">' + (FAM_LABELS[e[0]] || e[0]) + '</span>';
        }).join('');
      }
      if (elPair && s.pair) {
        elPair.innerHTML = s.pair.map(function (p) {
          return '<span class="h-textlink" style="cursor:default">' + p + '</span>';
        }).join('');
      }
    }
    var nextBtn = compare.querySelector('[data-compare-next]');
    var prevBtn = compare.querySelector('[data-compare-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { renderCompare(idx + 1); });
    if (prevBtn) prevBtn.addEventListener('click', function () { renderCompare(idx - 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { renderCompare(k); }); });

    /* Swipe to switch scents (mobile) — horizontal-dominant gestures only,
       passive listeners so vertical page scroll is never blocked. */
    var swipeEl = compare.closest('.hotelier-compare__layout') || compare;
    var sx = 0, sy = 0;
    swipeEl.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    swipeEl.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) renderCompare(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });

    renderCompare(0);
  }

  /* ---- Shop urgency: animated "sold this week" + inventory bar ---------- */
  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-target'), 10) || 0;
    if (reduceMotion || target <= 0) { el.textContent = target; return; }
    var start = null, dur = 1100;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      el.textContent = Math.round(p * target);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var soldEl = root.querySelector('[data-hotelier-sold]');
  var invFill = root.querySelector('[data-invbar-fill]');
  if ((soldEl || invFill) && 'IntersectionObserver' in window) {
    var target = soldEl ? soldEl.closest('.hotelier-stock') : invFill;
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (soldEl) animateCount(soldEl);
        if (invFill) invFill.style.width = (invFill.getAttribute('data-pct') || 0) + '%';
        io2.disconnect();
      });
    }, { threshold: 0.4 });
    io2.observe(target);
  } else {
    if (soldEl) soldEl.textContent = soldEl.getAttribute('data-target') || '';
    if (invFill) invFill.style.width = (invFill.getAttribute('data-pct') || 0) + '%';
  }

  /* ---- Reviews: reveal hidden cards in batches of 12 ---------------------- */
  var rvMore = root.querySelector('[data-rv-showmore]');
  if (rvMore) {
    rvMore.addEventListener('click', function () {
      var hiddenCards = root.querySelectorAll('[data-rv-more][hidden]');
      for (var i = 0; i < Math.min(12, hiddenCards.length); i++) hiddenCards[i].hidden = false;
      if (hiddenCards.length <= 12) rvMore.style.display = 'none';
    });
  }

  /* ---- Ritual mobile carousel: sync pagination dots ---------------------- */
  var ritualRow = root.querySelector('.hotelier-ritual__row');
  var ritualDots = root.querySelectorAll('[data-ritual-dot]');
  if (ritualRow && ritualDots.length) {
    function syncRitualDots() {
      if (ritualRow.scrollWidth <= ritualRow.clientWidth) return; /* desktop grid — no carousel */
      var i = Math.max(0, Math.min(ritualDots.length - 1, Math.round(ritualRow.scrollLeft / ritualRow.clientWidth)));
      ritualDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    ritualRow.addEventListener('scroll', syncRitualDots, { passive: true });
    ritualDots.forEach(function (d, k) {
      d.addEventListener('click', function () {
        ritualRow.scrollTo({ left: k * ritualRow.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---- Cart drawer (structural twin of the FluffCo cart) ----------------- */
  var FREE_SHIP_CENTS = 7500; /* $75 — matches the trust row */
  var cartEl = document.getElementById('hotelier-cart');
  var cartOverlay = document.getElementById('hotelier-cart-overlay');

  function cash(cents) {
    var n = (cents || 0) / 100;
    return '$' + Math.floor(Math.round(n * 100) / 100 + 1e-9); // whole dollars, rounded DOWN (11/3/26)
  }
  function updateCount(n) {
    document.querySelectorAll('[data-hotelier-cart-count]').forEach(function (el) {
      el.textContent = '(' + (n || 0) + ')';
    });
    var badge = cartEl && cartEl.querySelector('[data-cart-count-badge]');
    if (badge) badge.textContent = n || 0;
  }

  function openCart() {
    if (!cartEl) return;
    cartEl.classList.add('open'); cartEl.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartEl) return;
    cartEl.classList.remove('open'); cartEl.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.documentElement.style.overflow = '';
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function imgUrl(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=180'; }

  function renderCart(cart) {
    if (!cartEl || !cart) return;
    updateCount(cart.item_count);
    var empty = cartEl.querySelector('[data-cart-empty]');
    var list = cartEl.querySelector('[data-cart-items]');
    var footer = cartEl.querySelector('[data-cart-footer]');
    var ship = cartEl.querySelector('[data-cart-ship]');
    var hasItems = cart.item_count > 0;

    if (empty) empty.classList.toggle('show', !hasItems);
    if (footer) footer.hidden = !hasItems;
    if (ship) ship.hidden = !hasItems;

    /* free-shipping progress */
    if (hasItems && ship) {
      var sub = cart.total_price;
      var label = ship.querySelector('[data-cart-ship-label]');
      var fill = ship.querySelector('[data-cart-ship-fill]');
      var unlocked = sub >= FREE_SHIP_CENTS;
      if (label) {
        label.textContent = unlocked ? 'Complimentary shipping unlocked'
          : 'You’re ' + cash(FREE_SHIP_CENTS - sub) + ' away from complimentary shipping';
        label.classList.toggle('unlocked', unlocked);
      }
      if (fill) {
        fill.style.width = Math.min(100, (sub / FREE_SHIP_CENTS) * 100) + '%';
        fill.classList.toggle('unlocked', unlocked);
      }
    }

    /* line items */
    if (list) {
      list.innerHTML = cart.items.map(function (it) {
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        /* final_line_price already includes automatic/line discounts */
        var lineFinal = it.final_line_price;
        var was = it.original_line_price > lineFinal ? '<span class="was">' + cash(it.original_line_price) + '</span>' : '';
        return '<li class="hotelier-citem" data-key="' + esc(it.key) + '">'
          + '<div>'
          +   (it.image ? '<img class="hotelier-citem__img" src="' + esc(imgUrl(it.image)) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '<div class="hotelier-citem__img"></div>')
          + '</div>'
          + '<div>'
          +   '<p class="hotelier-citem__name">' + esc(it.product_title) + '</p>'
          +   (variant ? '<p class="hotelier-citem__variant">' + esc(variant) + '</p>' : '')
          +   '<div class="hotelier-citem__rowbottom">'
          +     '<span class="hotelier-qtystep">'
          +       '<button type="button" data-cart-qty="-1" aria-label="Decrease quantity">−</button>'
          +       '<span>' + it.quantity + '</span>'
          +       '<button type="button" data-cart-qty="1" aria-label="Increase quantity">+</button>'
          +     '</span>'
          +     '<span class="hotelier-citem__price">' + was + cash(lineFinal) + '</span>'
          +   '</div>'
          +   '<button type="button" class="hotelier-citem__remove" data-cart-remove>Remove</button>'
          + '</div>'
          + '</li>';
      }).join('');
    }

    var subtotal = cartEl.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = cash(cart.total_price);

    /* Subscription offer note: with the code path, line prices show full
       price in-cart and the code discounts at checkout — say so plainly. */
    var offerEl = cartEl.querySelector('[data-cart-offer]');
    if (offerEl) {
      /* If a page applied a session discount CODE (Version C test pricing),
         the code only prices in at CHECKOUT \u2014 state the checkout total so the
         drawer never looks more expensive than what the customer will pay. */
      var sessOffer = recallOffer();
      var cartCount = cart.items.reduce(function (n, it) { return n + it.quantity; }, 0);
      if (hasItems && sessOffer && sessOffer.code && sessOffer.count === cartCount) {
        offerEl.hidden = false;
        offerEl.textContent = 'Offer price applies at checkout: ' + cash(sessOffer.total * 100) + ' total';
      } else if (hasItems && cart.total_discount > 0) {
        offerEl.hidden = false;
        offerEl.textContent = 'Suite discount applied: \u2212' + cash(cart.total_discount);
      } else {
        offerEl.hidden = true;
      }
    }
  }

  function refreshCart(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); return cart; })
      .catch(function () {});
  }

  function changeLine(key, qty) {
    return fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () { refreshCart(false); });
  }

  /* events */
  if (cartEl) {
    document.querySelectorAll('[data-hotelier-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); });
    });
    cartEl.querySelectorAll('[data-hotelier-cart-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        closeCart();
        if (b.hasAttribute('data-cart-shop-cta')) {
          var shopSec = document.getElementById('shop');
          if (shopSec) setTimeout(function () {
            window.scrollTo({ top: shopSec.getBoundingClientRect().top + window.scrollY - 64, behavior: reduceMotion ? 'auto' : 'smooth' });
          }, 250);
        }
      });
    });
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    /* delegated qty / remove */
    cartEl.addEventListener('click', function (e) {
      var item = e.target.closest('.hotelier-citem');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        var cur = parseInt(item.querySelector('.hotelier-qtystep span').textContent, 10) || 1;
        changeLine(key, Math.max(0, cur + parseInt(qtyBtn.getAttribute('data-cart-qty'), 10)));
        return;
      }
      if (e.target.closest('[data-cart-remove]')) changeLine(key, 0);
    });
  }

  /* expose for the ATC flow */
  window.hotelierCart = { open: openCart, refresh: refreshCart, render: renderCart };

  if (window.fetch) refreshCart(false);
})();
